import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS, ROLES} from "@/lib/auth/roles";
import PerformanceFirm from "@/modules/performance/firm";
import {ELEVATION_PERFORMANCE_FIRM_PATH, ELEVATION_PERFORMANCE_FIRM_URL} from "@/utils/urls";

export const Route = createFileRoute(ELEVATION_PERFORMANCE_FIRM_PATH)({
  component: PerformanceFirmPage,
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Firm performance', path: '#' },
        { label: 'Compare firm', path: ELEVATION_PERFORMANCE_FIRM_URL
        },
      ]
    }
  }
})

function PerformanceFirmPage() {
  return(
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[PERMISSIONS.IS_NETWORK_VIEW_ON_NETWORK]} forbiddenFallback={<Unauthorized />}>
        <PerformanceFirm />
      </Authorisation>
    </div>
  )
}
